<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-no" id="pt-1"><a id="page_10"> </a><a id="page_11">SECTION ONE</a></h1><a id="page_11">
<h1 class="part-title"><span class="brwn">Glass, Wood, and the Rock</span></h1>
<p class="image"><img alt="Image" src="images/11.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007_Part01.vue?4b83737b